export default "__VITE_ASSET__3a586454__"